import RootLayout from "@/app/layout";
import Head from "next/head";
import { HeaderSection } from "@/app/components/sections/HeaderSection";
import { useEffect, useState } from "react";

export const metadata = {
  title: 'Marlene Gujan Architektur AG',
  description: 'Marlene Gujan Architektur AG in Igis bietet innovative und massgeschneiderte Architekturlösungen für Ihre Bauprojekte.',
  keywords: 'Architektur, Igis, Marlene Gujan, Bauprojekte, Architekturdesign, innovative Lösungen',
  canonicalUrl: 'https://www.gujan-architektur.ch/'
}

export default function Home() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(`/api/getImages?folderpath=images/diashow`);
        const imageFiles = await response.json(); // assuming response is a JSON array of filenames
        const processedData = imageFiles.map(file => {
          const [id, projekt] = file.name.split('_');
          const projectId = projekt.split('.')[0];
          return {
            id,
            projekt: projectId,
            image: file
          };
        });

        setData(processedData);
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchImages();
  }, []);

  return (
    <RootLayout>
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <link rel="canonical" href={metadata.canonicalUrl} />
      </Head>
      {data && <HeaderSection data={data} />}
    </RootLayout>
  )
}
